module.exports = __webpack_public_path__ + "assets/img/home-swiper-3.075ffa44.png";